const updateItems = [
  {
    date: '2026.07.28',
    title: '《苍穹之刃》漫画全集完结收录上线',
    desc: '历时五年连载的热血战斗漫画终于迎来大结局，迷妹漫画网已完整收录全328话漫画完整版。',
    tag: '新作上架',
  },
  {
    date: '2026.07.26',
    title: '七月完结漫画推荐榜单更新',
    desc: '本月新增12部完结漫画大全，涵盖恋爱、悬疑、异世界等多个品类，下拉式阅读即刻体验。',
    tag: '榜单更新',
  },
  {
    date: '2026.07.24',
    title: '恋爱甜漫专区完结作品突破100部',
    desc: '迷妹漫画恋爱甜漫专区完结漫画全集数量正式突破三位数，糖分补给站持续扩充中。',
    tag: '里程碑',
  },
  {
    date: '2026.07.21',
    title: '网站移动端阅读体验全面升级',
    desc: '优化了手机浏览器下的下拉式漫画阅读流畅度，竖屏连续滚动更加丝滑自然。',
    tag: '功能更新',
  },
  {
    date: '2026.07.18',
    title: '悬疑推理完结漫画专题重磅上线',
    desc: '精选8部高口碑悬疑推理类漫画完整版，全部已完结，谜底一次性揭晓。',
    tag: '专题上线',
  },
  {
    date: '2026.07.15',
    title: '经典老漫重温计划启动',
    desc: '迷妹漫画网开始系统收录经典完结漫画全集，那些陪伴青春的传世之作陆续回归。',
    tag: '特别企划',
  },
  {
    date: '2026.07.12',
    title: '异世界题材完结漫画突破50部',
    desc: '从热门轻改到原创异世界冒险，终结转生穿越追更之苦，完整故事尽在迷妹漫画。',
    tag: '内容增长',
  },
  {
    date: '2026.07.08',
    title: '每日推荐算法优化完成',
    desc: '完结漫画推荐榜单现在更加精准，根据你的阅读偏好智能推荐值得补的漫画全集。',
    tag: '体验优化',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            迷妹漫画网的内容更新、功能优化和运营动态一览
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updateItems.map((item, i) => (
            <div
              key={i}
              className="flex gap-4 pb-6 mb-6 border-b border-background-200/60 last:border-b-0"
            >
              <div className="shrink-0 w-20 md:w-24 pt-0.5">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}